import React from 'react';
import SafeIcon from '../common/SafeIcon';

const QuickPanel = ({ icon, title, tools, emptyText, onOpen }) => (
  <section className="quick-panel">
    <div className="quick-panel-heading">
      <SafeIcon name={icon} />
      <h2>{title}</h2>
      <span>{tools.length}</span>
    </div>
    <div className="quick-panel-list">
      {tools.length ? tools.slice(0, 4).map((tool) => (
        <a
          key={tool.id}
          href={tool.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onOpen(tool.id)}
          className="quick-tool"
        >
          <span
            className="quick-tool-icon"
            style={{ color: tool.iconColor, borderColor: `${tool.iconColor}38` }}
          >
            <SafeIcon name={tool.icon} />
          </span>
          <span className="min-w-0 flex-grow">
            <strong>{tool.label}</strong>
            <small>{tool.title}</small>
          </span>
          <SafeIcon name="ArrowUpRight" className="quick-tool-arrow" />
        </a>
      )) : (
        <p className="quick-empty">{emptyText}</p>
      )}
    </div>
  </section>
);

const QuickAccess = ({ favourites, recent, onOpen }) => (
  <div className="quick-access-grid">
    <QuickPanel
      icon="Star"
      title="My favourites"
      tools={favourites}
      emptyText="Star a tool to keep it close."
      onOpen={onOpen}
    />
    <QuickPanel
      icon="Clock"
      title="Recently opened"
      tools={recent}
      emptyText="Tools you open will appear here."
      onOpen={onOpen}
    />
  </div>
);

export default QuickAccess;